import styled from "styled-components";

export const StyledContainer = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  margin: 1.25rem 0;
  background: ${(props) => props.theme.main.background};
  background-size: contain;
  box-shadow: 0.3125rem 0.3125rem 0.3125rem 0px rgba(0, 0, 0, 0.3);
  filter: drop-shadow(0.3125rem 0.3125rem 0.3125rem rgba(0, 0, 0, 0.3));
`;

export const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 1.5rem;
  box-sizing: border-box;
`;

export const StyledImageContainer = styled.div`
  display: flex;
  min-width: 35%;
  max-width: 35%;
  /* flex-grow: 1; */
  justify-content: center;
  align-items: center;

  img {
    border: 0.3125rem solid ${(props) => props.theme.main.fontsColor.border};
    height: 11.5rem;
    border-radius: 0.125rem;
  }
`;

export const StyledLabel = styled.div`
  min-width: 60%;
  max-width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  h1 {
    font-size: 2.6875rem;
    line-height: 1.0;
    color: ${(props) => props.theme.main.fontsColor.name};
    text-transform: uppercase;
  }

  h3 {
    font-size: 1.5rem;
    color: ${(props) => props.theme.main.fontsColor.label};
  }
`;

export const StyledText = styled.div`
width: 100%;
box-sizing: border-box;
  font-size: 1.125rem;
  text-align: justify;
  flex-grow: 1;
  padding: 0 2.5rem 0 2.5rem;
  margin-bottom: 1.5rem;
  color: ${(props) => props.theme.main.fontsColor.text};
`;

export const StyledQuoteText = styled.div`
  font-size: 1.5rem;
  text-align: center;
  margin: 1.5rem 2.5rem 0 2.5rem;
  color: ${(props) => props.theme.main.fontsColor.label};
  border: 0.3125rem solid ${(props) => props.theme.main.fontsColor.border};
  padding: 0.3125rem 0.625rem 0.3125rem 0.625rem;
`;

export const StyledButton = styled.div`
  width: 5.25rem;
  height: 1.25rem;
  font-size: 1.125rem;
  line-height: 1.25rem;
  color: #2b1a13;
  padding: 0.3125rem;
  background-color: none;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  margin-top: 0.625rem;

  &:hover {
    color: #c97b74;
  }
`;
